import React from 'react';
import styled from 'styled-components';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = styled(ToastContainer)`
  .Toastify__toast--info {
    background: 'rgb(51, 102, 255)';
  }
  .Toastify__toast--success {
    background: 'rgb(51, 187, 102)';
  }
  .Toastify__toast--warning {
    background: 'rgb(254, 255, 20)';
  }
  .Toastify__toast--error {
    background: 'rgb(255, 102, 102)';
  }
`;
export const showToast = ({ type, message }) => {
  switch (type) {
    case 'success':
      toast.success(message, {
        position: 'bottom-right',
        autoClose: 10000,
        toastId: 'toast-login.success',
      });
      break;
    case 'warn':
      toast.warn(message, {
        position: 'bottom-right',
        autoClose: 10000,
      });
      break;
    case 'error':
      toast.error(message, {
        position: 'bottom-right',
        autoClose: 10000,
      });
      break;
    default:
      toast.info(message, {
        position: 'bottom-right',
        autoClose: 10000,
      });
  }
};
export default function ToastAnimated() {
  return <Toast />;
}
